import { useTranslation } from 'react-i18next';
import { Star } from 'lucide-react';
import { CapacityCell } from '@/components/capacity-cell';
import type { CapacityBinding } from '@bliks-io/contracts';

interface ProcessStatsProps {
  totalSteps: number;
  averageRating: number | null;
  capacityBinding: CapacityBinding | null;
}

export function ProcessStats({ totalSteps, averageRating, capacityBinding }: ProcessStatsProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-6 mb-6">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-gray-8">{t('processes.totalSteps')}</span>
        <span className="text-2xl font-semibold">{totalSteps}</span>
      </div>

      <div className="w-px h-6 bg-gray-3" />

      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-gray-8">{t('processes.rating')}</span>
        <div className="flex items-center gap-1">
          <Star className="h-5 w-5 fill-[#FFC107] text-[#FFC107]" />
          <span className="text-2xl font-semibold">
            {averageRating ? averageRating.toFixed(1) : 'N/A'}
          </span>
        </div>
      </div>

      {capacityBinding && (
        <>
          <div className="w-px h-6 bg-gray-3" />

          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-gray-8">
              {t('processes.capacityBinding')}
            </span>
            <CapacityCell
              capacity={capacityBinding}
              className="text-2xl"
              confidence={capacityBinding.confidence}
            />
          </div>
        </>
      )}
    </div>
  );
}
